import { FC } from 'react';

import Info, { InfoTypes } from '@zvuk-b2b/react-uikit/ui/Info';

import { TEXTS } from '../PromoRollSynthModal/texts';
import { LIMIT_WARNING_THRESHOLD } from '../PromoRollSynthModal/consts';
import styles from './LimitInfo.module.scss';

type Props = {
  remainingToday: number;
  dailyLimit: number;
};

const LimitInfo: FC<Props> = ({ remainingToday, dailyLimit }) => {
  if (remainingToday === 0) {
    return <Info type={InfoTypes.ERROR}>{TEXTS.LIMIT_EXHAUSTED(dailyLimit)}</Info>;
  }

  if (remainingToday <= LIMIT_WARNING_THRESHOLD) {
    return <span className={styles.warning}>{TEXTS.LIMIT_WARNING(remainingToday)}</span>;
  }

  return null;
};

export default LimitInfo;
